import React, { useReducer, createContext } from "react";
import { panelInitialState, panelReducer } from "../reducers";
import constant from "../constants/panelConstant";

export const PanelContext = createContext();

export const PanelContextProvider = (props) => {

    const [state, dispatch] = useReducer(panelReducer, panelInitialState);

    const openModalPanel = (content, title) => {

        dispatch({ type: constant.OPEN_MODAL_PANEL, payload: { content, title } });
    };

    const closeModalPanel = () => {

        dispatch({ type: constant.CLOSE_MODAL_PANEL });
    }

    return (
        <PanelContext.Provider value={[
            state,
            {
                openModalPanel,
                closeModalPanel
            }
        ]}>
            {props.children}
        </PanelContext.Provider>
    );
};